var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiticon = function SvgFiticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.532 7.57a.427.427 0 0 1-.42.42L3.55 7.984a.419.419 0 0 1-.297-.711L4.44 6.088 1.773 3.422a.419.419 0 0 1 0-.592l.593-.593a.419.419 0 0 1 .592 0l2.666 2.666L6.81 3.718a.419.419 0 0 1 .723.296V7.57Zm5.296 1.618a.419.419 0 0 0-.385-.262H8.89a.427.427 0 0 0-.421.42v3.555a.419.419 0 0 0 .71.296l1.186-1.184 2.666 2.666a.419.419 0 0 0 .592 0l.593-.593a.419.419 0 0 0 0-.592l-2.666-2.666 1.185-1.185a.42.42 0 0 0 .094-.455Z",
    clipRule: "evenodd"
  })));
};
export default SvgFiticon;